import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export type VoucherGreetingOption = {
    value: string;
    label: string;
    key: string;
};

export function useVoucherCatalog() {
    const page = usePage();

    const amounts = computed(() => (page.props.voucherAmounts as number[] | undefined) ?? []);

    const amountOptions = computed(() => amounts.value.map(String));

    const greetingOptions = computed(
        () => (page.props.voucherGreetings as VoucherGreetingOption[] | undefined) ?? [],
    );

    const defaultAmount = computed(() => amounts.value[0] ?? 25);

    const defaultGreeting = computed(() => greetingOptions.value[0]?.value ?? '');

    return {
        amounts,
        amountOptions,
        greetingOptions,
        defaultAmount,
        defaultGreeting,
    };
}
